import { useCurrentProfile } from '@map/state/profile';
import { windowExtended } from '@map/types';
import { SUPPORTED_APP_LANGUAGES } from '@shared/appConstants';
import { useCallback } from 'react';
import { useCurrentUser, useUpdateLocalUser, useUpdateLocale } from './userApi';

export const useUpdateLanguage = () => {
  const user = useCurrentUser();
  const updateLocale = useUpdateLocale();
  const updateLocalUser = useUpdateLocalUser();

  return useCallback(
    (locale: string) => {
      updateLocale({ id: user.id, locale }).catch(() => {
        if (!navigator.onLine) {
          updateLocalUser({ ...user, locale });
        }
      });
    },
    [updateLocale, user, updateLocalUser],
  );
};

export const useAllowedLanguages = () => {
  const profile = useCurrentProfile();

  return (
    profile.allowed_languages || windowExtended.project.allowed_languages || SUPPORTED_APP_LANGUAGES
  );
};
